'use client'
import * as React from 'react';

var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgSwitchToggle = function SvgSwitchToggle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7B7D86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.417 10.102v-8.89c.012-.12.022-.3.224-.496a.782.782 0 0 1 1.08 0l3.056 2.955a.722.722 0 0 1 0 1.044.782.782 0 0 1-1.08 0L7.944 3.022v7.08a.752.752 0 0 1-.764.739.752.752 0 0 1-.764-.739ZM4.583 3.898v8.89c-.012.12-.022.3-.224.496a.782.782 0 0 1-1.08 0L.223 10.329a.722.722 0 0 1 0-1.044.782.782 0 0 1 1.08 0l1.752 1.693v-7.08c0-.408.342-.739.764-.739s.764.33.764.739Z"
  }))));
};

export { SvgSwitchToggle as ReactComponent };
